import { render, staticRenderFns } from "./DashboardHeader.vue?vue&type=template&id=da92d508&"
import script from "./DashboardHeader.vue?vue&type=script&lang=js&"
export * from "./DashboardHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/devteam/projects/dominion-conference-app/ConferenceAdmin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports